import React from "react";
import "./Footer.css";
import { useNavigate, Link } from "react-router-dom";
import FacebookIcon from "@mui/icons-material/Facebook";
import XIcon from "@mui/icons-material/X";
import YouTubeIcon from "@mui/icons-material/YouTube";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

export const Footer = () => {
  const navigate = useNavigate();

  return (
    <div className="footer">
      <p className="footerHeading">MOORINGMATE</p>
      <div className="navContainer">
        <p>Yachts</p>
        <p>Blog</p>
        <p>Company</p>
        <p>Shippers</p>
        <p>Testimonials</p>
      </div>
      <div className="iconContainer">
        <FacebookIcon />
        <XIcon />
        <YouTubeIcon />
        <InstagramIcon />
        <LinkedInIcon />
      </div>
      <p>
        {"Copyright © "}
        <Link style={{ color: "white" }} to="/">
          Mooringmate
        </Link>{" "}
        {new Date().getFullYear()}
        {"."}
      </p>
    </div>
  );
};
